var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02DE89C9-5F4B-472B-B800-A5974F74F2F4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rides---Reservations",
    transform: "translate(-154.000000, -261.000000)",
    fill: "#7C8195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(154.000000, 261.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.58502,9.64873363 L17.4046884,9.64873363 L16.9943968,10.0560288 C18.4437965,11.7461552 19.3253288,13.9372249 19.3253288,16.3378881 C19.3253288,21.6743468 14.9994282,26 9.66266438,26 C4.32590051,26 0,21.6743468 0,16.3378881 C0,11.0014293 4.32590051,6.67577611 9.66266438,6.67577611 C12.0634648,6.67577611 14.2531732,7.55577154 15.9433962,9.00360185 L16.3536878,8.59630667 L16.3536878,7.41901549 L23.7835334,0 L26,2.21633983 L18.58502,9.64873363 L18.58502,9.64873363 Z M9.66266438,9.64873363 C5.9670669,9.64873363 2.9731275,12.6425019 2.9731275,16.3378881 C2.9731275,20.0317878 5.9670669,23.0270425 9.66266438,23.0270425 C13.3567753,23.0270425 16.3522013,20.0317878 16.3522013,16.3378881 C16.3522013,12.6425019 13.3567753,9.64873363 9.66266438,9.64873363 L9.66266438,9.64873363 Z",
    id: "Shape",
    transform: "translate(13.000000, 13.000000) scale(1, -1) translate(-13.000000, -13.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.7ec513e7c231ee835289cd76612d31fa.svg";
export { ForwardRef as ReactComponent };